export class Email {
  Email :any='';
     Name :any='';
  ContactNumber :any='';
    Subject :any='';
    UserQuery :any='';
}
